/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, OnInit } from '@angular/core';
import { FnPipe } from '../pipe/fn.pipe';
import { CdsLanguageModule } from '@cds/ng-core/lang';

@Component({
  selector: 'app-icon-status',
  templateUrl: './icon-status.component.html',
  styleUrls: ['./icon-status.component.scss'],
  imports: [FnPipe, CdsLanguageModule],
})
export class IconStatusComponent implements OnInit {
  @Input() value?: any;
  @Input() statusMapObj?: any;

  colorStyle = '';

  text = '';

  constructor() {}

  ngOnInit(): void {}

  getStatusColorStyle(value: string, mapObj: any) {
    if (!value) {
      return '';
    }
    return `background-color: ${mapObj[value]?.color};`;
  }

  getStatus(value: string, mapObj: any) {
    if (!value) {
      return '';
    }
    return mapObj[value]?.text;
  }
}
